import router from './router'
import store from './store'
import { SET_LOGIN_USER_INFO } from '@/store/modules/user'
import { setToken, getToken } from '@/utils/auth'
import { thirdAuthUrl } from '@/api/loginToB.js'

router.beforeEach(async(to, from, next) => {
  // 获取当前token
  let hasToken = getToken()
  // 跳转到登录页
  if (to.name === 'Login') {
    // 请求logo
    await store.dispatch('dict/getLogo', to.params.name.toLowerCase() === 'user')
    next()
    return
  }
  // 如果需要跳转到C端首页
  if (to.name === 'UserHome') {
    // 如果当前有token
    if (to.query.token) {
      setToken(to.query.token)
      hasToken = getToken()
    }

    // 开始派发时间
    store.commit(`user/${SET_LOGIN_USER_INFO}`, {
      vin: to.query.vin || '',
      token: hasToken,
      type: 'C',
      phone: to.query.phone || ''
    })
    // 请求logo
    await store.dispatch('dict/getLogo', true)
    next()
    return
  }
  if (from.path === '/' && to.name !== 'CiamLogin' && to.path !== '/authLogin') {
    // 如果当前没有token，则直接跳转登录页
    // =======测试环境修改-begin-=======
    // 跳转过是否有token的验证,token可以保存在cookis里
    // ======修改前:
    if (!hasToken) {
    // ======修改后:
    // if (hasToken) {
    // =======测试环境修改-end-=======

      // const metaType = to.meta.type || 'business'
      // // 请求logo
      // await store.dispatch('dict/getLogo', {
      //   isCustomer: metaType.toLowerCase() === 'user'
      // })
      // return next({
      //   name: 'Login',
      //   params: { name: metaType },
      //   query: {
      //     ...(to.query || {})
      //   }
      // })

      // 如果是从奔驰auth认证登录的本系统，则清除source标识，并且转到gas的登录地址
      const source = localStorage.getItem('source')
      localStorage.removeItem('source')
      console.log('permission.js')
      thirdAuthUrl({ target: source === 'CIAM' ? 'ciam' : 'auth', type: 'LOGIN' }).then(url => { window.location = url })
    } else {
      // 请求logo和字典项
      await Promise.all([
        store.dispatch('dict/getLogo', {
          isCustomer: store.getters.loginUser.type === 'C'
        }),
        store.dispatch('dict/initDict')
      ])
    }
  }
  next()
})




// WEBPACK FOOTER //
// ./src/permission.js